import * as React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Grid } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import './UnidentifiedProductsModal.scss';

interface IUnidentifiedModalProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  content: React.ReactNode;
  onClose(): void;
}

class UnidentifiedProductsModal extends React.Component<IUnidentifiedModalProps> {
  public render() {
    const { open, handleClose, title, content } = this.props;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ style: { width: "80%", height: "60%" } }}
      >
        <DialogTitle className="dialogTitle">
          {title}
          <IconButton onClick={handleClose} className="closeButton">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid className="item-grid" container={true} spacing={8}>
            {content}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default UnidentifiedProductsModal;



// WEBPACK FOOTER //
// ./src/component/administration/unidentified-products-list/UnidentifiedProductsModal.tsx